import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store/Store";
import {
  getParticipantById,
  updateParticipantStatus,
} from "../Participants/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    participant: state.participantsReducer.currentParticipant,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getParticipantById,
      updateParticipantStatus,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
